import { FC } from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';
import {
  useSearchInputContext, type SearchRefs,
} from 'src/common/components/Search/SearchInputProvider';
import { useSearchHeroModalContext } from 'src/common/components/Search/SearchHero/SearchHeroModalProvider';
import { useSearchDateHandlers } from 'src/common/components/Search/useSearchDateHandlers';
import DatesInputFilter from 'src/common/components/DatesInputFilter';
import styles from './PopoverDates.module.scss';

export type Props = {
  refs: SearchRefs;
};

const PopoverDates: FC<Props> = ({
  refs,
}) => {
  const { filterDates, isDesktop } = useSearchInputContext();
  const modal = useSearchHeroModalContext();
  const {
    dateRangeOptions, handleDateFilterChange, rangeOption, highlightDates,
  } = useSearchDateHandlers(refs);

  const isOpen = modal.isDatesOpen;
  const disabled = !isDesktop || !isOpen;

  const closeOutsideRef = useOnclickOutside(() => {
    modal.close();
  }, { disabled, refs: [refs?.inputs] });

  if (disabled) return null;

  return (
    <div
      ref={closeOutsideRef}
      className={styles.root}
    >
      <DatesInputFilter
        dates={filterDates}
        dateRangeOptions={dateRangeOptions}
        rangeOption={rangeOption}
        showClearButton
        highlightDates={highlightDates}
        classNameModifier="mainSearchPage"
        onChange={handleDateFilterChange}
        monthsShown={2}
        collapseLastRowIfEmpty
      />
    </div>

  );
};

export default PopoverDates;
